import React from 'react';
import { 
    Create, 
    SimpleForm, 
    ReferenceInput,
    SelectInput,
    BooleanInput,
    required
} from 'react-admin';
import { Typography, Box } from '@mui/material';
import { FormToolbar } from "../../common/FormToolbar";

const SectionTitle = ({ children }) => (
    <Box sx={{ mt: 3, mb: 2 }}>
        <Typography variant="h6" gutterBottom>
            {children}
        </Typography>
    </Box>
);

// Access level choices
const accessLevelChoices = [
    { id: 'VIEW', name: 'View Only - Can view data but cannot edit' },
    { id: 'EDIT', name: 'Edit - Can view and modify data' },
    { id: 'ADMIN', name: 'Admin - Full access including delete' },
];

export const UserBranchAccessCreate = props => {
    return (
        <React.Fragment>
            <Create label="Grant Branch Access" {...props}>
                <SimpleForm toolbar={<FormToolbar {...props} />}>
                    <SectionTitle>User Branch Access Configuration</SectionTitle>
                    
                    <ReferenceInput 
                        source="user_id" 
                        reference="user" 
                        label="User"
                        fullWidth={true}
                    >
                        <SelectInput optionText="username" validate={[required()]} />
                    </ReferenceInput>

                    <ReferenceInput 
                        source="branch_id" 
                        reference="branch" 
                        label="Branch"
                        fullWidth={true}
                    >
                        <SelectInput optionText="branch_name" validate={[required()]} />
                    </ReferenceInput>

                    <SelectInput 
                        source="access_level" 
                        label="Access Level" 
                        choices={accessLevelChoices} 
                        defaultValue="VIEW"
                        validate={[required()]} 
                        fullWidth={true}
                        helperText="Define what level of access this user has for this branch"
                    />

                    <BooleanInput 
                        source="is_primary_branch" 
                        label="Set as Primary Branch" 
                        helperText="User's primary branch will be the default branch in the system"
                        defaultValue={false}
                    />

                    <BooleanInput 
                        source="status" 
                        label="Active" 
                        helperText="Only active access grants are effective"
                        defaultValue={true}
                    />
                </SimpleForm>
            </Create>
        </React.Fragment>
    );
};
